module.exports = __webpack_public_path__ + "static/media/product-main.9d3b970e.svg";